import type { Theme } from '../settings/settings';

export const DARK_THEME_QUERY = '(prefers-color-scheme: dark)';

export function resolveSystemTheme(mediaQuery: Pick<MediaQueryList, 'matches'>): Theme {
  return mediaQuery.matches ? 'dark' : 'light';
}
